// extracted by mini-css-extract-plugin
export default {"container":"ChangeOwnerUnit_container__tKhDP","card":"ChangeOwnerUnit_card__ChP-5","content":"ChangeOwnerUnit_content__7Bw7T"};